export enum SmallWallMaterial {
  SmoothConcrete = 1,
  BSMVulcanRed = 2,
  BSMRubyRed = 3,
  BSMVictoriaBlack = 4,
  Silex = 5
};